import url from './url'
const AppConsts = {
	appName: 'title',
	subName: 'sub title',
	userManagement: {
		defaultAdminUserName: 'admin'
	},
	localization: {
		defaultLocalizationSourceName: 'FengCloud'
	},
	authorization: {
		encrptedAuthTokenName: 'enc_auth_token'
	},
	remoteServiceBaseUrl: url,
}
export default AppConsts
